import { TicketItem } from "webshop-modules";
import { ArtistSearchResult, DateTimeZone, SearchResult } from "webshop-api";

export class AnalyticsItemsProvider {

    public static setupAnalyticsEventItems(results: SearchResult[]): Partial<TicketItem>[] {
        return results.map((item, index) => {
            const partialItem = {
                index: index,
                item_name: item.title ?? '-',
                item_category: item.itemType ?? '',
                item_list_id: item.itemType ?? '-',
                item_list_name: item.itemType ?? '-',
            }

            if (item.events) {
                const cities = item.events.map(event => event.city);
                const venues = item.events.map(event => event.venue);

                Object.assign(partialItem, {
                    item_event_date: (item.events[0].dateStart as unknown as DateTimeZone).dateTime.toString(),
                    item_event_city: [...new Set(cities)].join(','),
                    item_event_venue: [...new Set(venues)].join(','),
                });
            }

            if (item.itemType === 'artist') {
                Object.assign(partialItem, {
                    item_artist_name: item.title ?? '-',
                });
            }

            return partialItem;
        });
    }

    public static setupAnalyticsArtistItems(artists: ArtistSearchResult[]): Partial<TicketItem>[] {
        return artists.map((item, index) => ({
            index: index,
            item_name: item.title,
            item_artist_name: item.title,
        }));
    }

}
